import Cookie from '../../../utils/cookies';

export function getEmail() {
  const email = Cookie.get('MSCSAuthDetails')
    ? Cookie.get('MSCSAuthDetails').split('=')[1]
    : '';
  return email;
}
export function getSsoid() {
  const ssoid = Cookie.get('ssoid');
  return ssoid;
}
export function getTicketid() {
  const ticketid = Cookie.get('TicketId');
  return ticketid;
}
export function getAboundToken() {
  const aboundToken = Cookie.get('aboundToken');
  return aboundToken;
}

export function postLoginActions() {
  return (
    window.AboundCashWidget &&
    typeof window.AboundCashWidget.PostLoginActions === 'function' &&
    window.AboundCashWidget.PostLoginActions({
      ticketId: getAboundToken(),
    })
  );
}

export function destroyAction(type) {
  return (
    window.AboundCashWidget &&
    typeof window.AboundCashWidget.destroyAction === 'function' &&
    window.AboundCashWidget.destroyAction({ widgetType: type })
  );
}

export function postLogoutActions() {
  return (
    window.AboundCashWidget &&
    typeof window.AboundCashWidget.logoutAction === 'function' &&
    window.AboundCashWidget.logoutAction()
  );
}
